module.exports = __webpack_public_path__ + "img/close.0f2a7c6d.png";